import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ArrowButton, ButtonWrapper, PrimaryButton } from "Buttons";
import styled from "styled-components";
import MapBlocksToComponents from "Helpers/BlockHelper";
import { StandardImage } from "Components/StandardImage";

import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { RTEWrapper, ContentWrapper, ElementAreaWrapper } from "BaseComponents/Wrappers";
import { Ingress, PageHeader } from "BaseComponents/Text/";
const LinkWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	${media.greaterThan(breakpoints.mobile)`
		margin-bottom: 20px;

	`}
	${ButtonWrapper} {
		${media.lessThan(breakpoints.mobile)`
			margin: 0;
		`}
		display: flex;
		margin: 0 10px 10px 0;
		justify-content: space-between;
	}
	${media.lessThan(breakpoints.mobile)`
        ${PrimaryButton}{
            margin-top: 0; 
        }
        flex-direction: column;
        `}
`;
let PassagePage = ({ Heading, Preamble, Text, Image, ImageText, Children, TopElementArea }) => {
	return (
		<>
			<PageHeader Heading={Heading} margin="0 0 15px 0" />
			<LinkWrapper>
				{Children.map((link, i) => {
					return <ArrowButton key={i} {...link} />;
				})}
			</LinkWrapper>
			<ElementAreaWrapper>
				{TopElementArea.length > 0 && MapBlocksToComponents(TopElementArea)}
			</ElementAreaWrapper>
			{Preamble && (
				<Ingress
					marginSmall="0 0 15px 0"
					margin="0 0 10px 0"
					dangerouslySetInnerHTML={{
						__html: Preamble,
					}}
				></Ingress>
			)}
			<ContentWrapper>
				{Image && <StandardImage src={Image} byline={ImageText} />}
				{Text && (
					<RTEWrapper
						dangerouslySetInnerHTML={{
							__html: Text,
						}}
					></RTEWrapper>
				)}
			</ContentWrapper>
		</>
	);
};

PassagePage.propTypes = {
	Heading: PropTypes.string,
	Text: propTypes.string,
};

export default PassagePage;
